import React, { Component, Fragment } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import CadeComponentHeader from './CadeComponentHeader';
import CadeReportPerson from './CadeReportPerson';
import CadeComponentDoodle from './CadeComponentDoodle';
import CadeReportDomain from './CadeReportDomain';
import authService from '../../services/AuthService';
import api, { apiErrorHandler, apiResponseHandler } from '../../services/AxiosService';

import ReactPlayer from 'react-player';
import Tour from '../../productTour/Tour';
import { apiErrorPopup } from '../../helpers/MessagePopup';

class CadeReportDomainComponent extends Component {
    constructor(props) {
        super(props);

        this.state = {
            assessmentId: props.assessmentId,
            providerId: props.providerId,
            cadeMode: props.cadeMode,
            cadeModeFor: props.cadeModeFor,
            cadeDomain: props.cadeDomain,
            domainDisplayName: props.domainDisplayName,
            domainImage: props.cadeDomain + "LG.png",
            navUpdateReportHandler: props.navUpdateReportHandler,
            domainImpressions: null,
            includeDomain: true,
            includeDomainDescription: true,
            includeDomainRadarChart: true,
            includeDomainTypical: true,
            includeDomainConcerns: true,
            includeDomainRecommendations: true,
            readonly: false
        }
        this.domainReportKey = 1;
    }

    generateDomainReportKey = () => {
        return new Date().getTime() + this.state.cadeModeFor;
    }

    navUpdateReportHandler = (newIcon) => {
        this.state.navUpdateReportHandler(newIcon);
    }

    saveHandler = (assessmentId, cadeDomain, domainImpressions, includeDomain, includeDomainDescription, includeDomainRadarChart, includeDomainTypical, includeDomainConcerns, includeDomainRecommendations) => {
        
        let reportModel = {
            assessmentId: assessmentId,
            domainName: cadeDomain,
            domainImpressions: domainImpressions,
            includeDomain: includeDomain,
            includeDomainDescription: includeDomainDescription,
            includeDomainRadarChart: includeDomainRadarChart,
            includeDomainTypical: includeDomainTypical,
            includeDomainConcerns: includeDomainConcerns,
            includeDomainRecommendations: includeDomainRecommendations
        }

        let url = "/assessment/" + this.state.assessmentId + "/reportconfig";
        api.post(url, reportModel,
        {
            headers: {
                Authorization: 'Bearer ' + authService.token
            }
        })
        .then((response) => {
            if (response.status == 200) {
                this.domainReportKey = this.generateDomainReportKey();
                this.setState({
                    domainImpressions: domainImpressions,
                    includeDomain: includeDomain,
                    includeDomainDescription: includeDomainDescription,
                    includeDomainRadarChart: includeDomainRadarChart,
                    includeDomainTypical: includeDomainTypical,
                    includeDomainConcerns: includeDomainConcerns,
                    includeDomainRecommendations: includeDomainRecommendations
                });
            }
            else {
                apiErrorPopup(apiResponseHandler(response));
            };
        })
        .catch((error) => {
            // Major problem - should not happen.  Back to login?
            apiErrorPopup(apiErrorHandler(error));
        });
    }

    componentDidMount = () => {
        if (authService.isPartnerProvider) {
            // Partner providers have no access at the domain level for reports.
            return;
        }
        let url = "assessment/" + this.state.assessmentId + "/reportconfig/" + this.state.cadeDomain + "/uid/" + authService.authenticatedUserId + "/ut/" + this.state.cadeModeFor;
        api.get(url, {
            headers: {
                Authorization: 'Bearer ' + authService.token
            }
        })
        .then((response) => {
            if (response.status == 200) {
                this.domainReportKey = this.generateDomainReportKey();
                this.setState({
                    domainImpressions: response.data.domainImpressions,
                    includeDomain: response.data.includeDomain,
                    includeDomainDescription: response.data.includeDomainDescription,
                    includeDomainRadarChart: response.data.includeDomainRadarChart,
                    includeDomainTypical: response.data.includeDomainTypical,
                    includeDomainConcerns: response.data.includeDomainConcerns,
                    includeDomainRecommendations: response.data.includeDomainRecommendations,
                    readonly: response.data.authenticatedUserReadonly
                });

            }
            else {
                apiErrorPopup(apiResponseHandler(response));
            }
        })
        .catch(error => {
            // Major problem - should not happen.
            apiErrorPopup(apiErrorHandler(error));
        });
    }

    render() {
        
        return (
            <Fragment>
                <Tour
                    name="Report"
                    key="Report"
                />
                <Container fluid>
                    <Row>
                        <Col sm={4}>
                            <CadeComponentHeader
                                cadeDomain={this.state.domainDisplayName}
                                subTitle="Report Notes"
                            />
                        </Col>
                        {false &&
                            <Col className="cadeComponent_videoHelp" sm={8}>
                                <Row>
                                    <Col className="cadeComponent_videoCol" sm={6}>
                                        <h6>How to Generate a Report</h6>
                                        <div class="cadeComponent_playerWrapper">
                                            <ReactPlayer className="cadeComponent_player" url='https://vimeo.com/392049416/d641b98ef0' controls={true} width='100%' height="100%" />
                                        </div>
                                    </Col>

                                    <Col className="cadeComponent_videoCol" sm={6}>
                                        <h6>Understanding Report Information</h6>
                                        <div class="cadeComponent_playerWrapper">
                                            <ReactPlayer className="cadeComponent_player" url='https://vimeo.com/392519032/64f0038c03' controls={true} width='100%' height="100%" />
                                        </div>
                                    </Col>
                                </Row>
                            </Col>
                        }
                    </Row>
                    <Row>
                        <Col sm={4}>
                            <CadeComponentDoodle
                                domainImage={this.state.domainImage}
                                resClickHandler={null}
                                resources={null}
                                resKey={0}
                            />
                        </Col>
                        <Col sm={8}>
                            <CadeReportPerson
                                personFirstName={this.props.personFirstName}
                                personLastName={this.props.personLastName}
                                personBirthDate={this.props.personBirthDate}
                                assessmentDate={this.props.assessmentDate}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={12}>
                            <CadeReportDomain
                                assessmentId={this.state.assessmentId}
                                cadeDomain={this.state.cadeDomain}
                                domainName={this.state.domainDisplayName}
                                domainImpressions={this.state.domainImpressions}
                                includeDomain={this.state.includeDomain}
                                includeDomainDescription={this.state.includeDomainDescription}
                                includeDomainRadarChart={this.state.includeDomainRadarChart}
                                includeDomainTypical={this.state.includeDomainTypical}
                                includeDomainConcerns={this.state.includeDomainConcerns}
                                includeDomainRecommendations={this.state.includeDomainRecommendations}
                                navUpdateReportHandler={this.navUpdateReportHandler}
                                domainChangeHandler={this.props.domainChangeHandler}
                                readonly={this.state.readonly}
                                saveHandler={this.saveHandler}
                                key={this.domainReportKey}
                            />

                        </Col>
                    </Row>
                </Container>
            </Fragment>
        )
    }
}

export default CadeReportDomainComponent;


// WEBPACK FOOTER //
// ./src/components/CadeComponent/CadeReportDomainComponent.js